import React, { useEffect, useState } from 'react';
import ClaimProfileHeader from '../auth/claimProfile/claimProfileStep1/ClaimProfileHeader';
import { VideoPop } from './common/videoPopup';
import { Link } from 'react-router-dom';
import './assets/css/lading-page.scss';

const DiyHvOffer = () => {
  const [vidID, setVidID] = useState(null),
    [isVideoPop, setIsVideoPop] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }, []);

  const openVideoModal = (url) => {
    setVidID(url);
    setIsVideoPop(true);
  };

  return (
    <>
      <ClaimProfileHeader />

      {/* HERO / BANNER */}
      <section className="banner-lp-sec diy-hv-banner">
        <div className="container">
          <div className="banner-flexbox">
            <div className="banner-content">
              <h1 className="title">
                Get College Coaches' Attention in 30 Seconds or Less
              </h1>
              <div className="short-text">
                <p>
                  <strong>The Formula That Gets You Recruited:</strong>
                </p>
                <p>
                  The Right Highlight Video + The Right Promotion + The Right
                  College Coaches = DMs, Texts, &amp; Recruiting Opportunities
                </p>
              </div>
              <div className="button-wrap">
                <a className="btn" href="#diy-offer-section">
                  Claim Your Spot &ndash; $299
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 15+ YEARS PROVEN RESULTS */}
      <section className="carrer-preferred-sec">
        <div className="container">
          <div className="top-block">
            <h3 className="sub-title">15+ Years of Proven Results</h3>
          </div>
          <div className="short-text" style={{ textAlign: 'center', color: '#989898', fontSize: '18px', lineHeight: '30px', marginBottom: '20px' }}>
            <p>
              SportsForce has been helping under-recruited athletes get REAL
              recruiting outcomes with:
            </p>
          </div>
          <div className="preferred-list">
            <div className="item">
              <div className="icon-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#00b9ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
              </div>
              <div className="detail-box">
                <h4>Coach-Approved Videos</h4>
                <p>
                  College coach-approved highlight videos designed to grab
                  attention in seconds.
                </p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#00b9ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                </svg>
              </div>
              <div className="detail-box">
                <h4>Strategic Promotion</h4>
                <p>
                  Strategic promotion systems that put your athlete in front of
                  the right coaches.
                </p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#00b9ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <div className="detail-box">
                <h4>Real Results</h4>
                <p>Results that lead to real offers and scholarship opportunities.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAST AFFORDABLE CUSTOMIZED */}
      <section className="athlete-team-sec-outer">
        <div className="container">
          <h3 className="sec-title">Fast. Affordable. Customized.</h3>
        </div>
        <div className="athlete-team-sec">
          <div className="container">
            <div className="content-box">
              <h3 className="title">Built for YOUR Athlete</h3>
              <div className="short-text">
                <p>
                  Built specifically for YOUR athlete and their recruiting goals.
                  Stop guessing and start getting responses from college coaches.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* EXAMPLE VIDEO SECTION */}
      <section className="diy-video-section" style={{ background: '#f5f5f5', padding: '60px 0', textAlign: 'center' }}>
        <div className="container">
          <h3 className="sec-title" style={{ fontSize: '36px', fontWeight: 600, marginBottom: '30px', color: '#333' }}>
            See What a Winning Highlight Video Looks Like
          </h3>
          <div className="video-box-wrap" style={{ maxWidth: '700px', margin: '0 auto' }}>
            <div className="video-img" style={{ position: 'relative' }}>
              <img
                src="https://i.vimeocdn.com/video/default_640"
                alt="Example highlight video"
                style={{ width: '100%', borderRadius: '8px' }}
              />
              <div className="video-play-button" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                <div className="video-play-inner">
                  <button className="play-btn" onClick={() => openVideoModal('https://player.vimeo.com/video/1000823828')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20.191" height="22.92" viewBox="0 0 20.191 22.92">
                      <path d="M9.086,27.982a2.255,2.255,0,0,1-1.1-.291,2.442,2.442,0,0,1-1.228-2.138V7.492A2.442,2.442,0,0,1,7.982,5.353a2.242,2.242,0,0,1,2.257.028l15.641,9.24a2.226,2.226,0,0,1,0,3.8L10.236,27.663a2.262,2.262,0,0,1-1.151.319Z" transform="translate(-6.754 -5.063)" fill="#c0321f" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="diy-testimonial-section" style={{ background: '#fff', padding: '60px 0' }}>
        <div className="container">
          <h3 className="sec-title" style={{ fontSize: '36px', fontWeight: 600, textAlign: 'center', marginBottom: '40px', color: '#333' }}>
            Real Results from Real Families
          </h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
            <div style={{ flex: '1 1 400px', maxWidth: '560px' }}>
              <div className="video-box-wrap">
                <div className="video-img" style={{ position: 'relative' }}>
                  <img
                    src="https://i.vimeocdn.com/video/default_640"
                    alt="Maguire Peterson Success Story"
                    style={{ width: '100%', borderRadius: '8px' }}
                  />
                  <div className="video-play-button" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <div className="video-play-inner">
                      <button className="play-btn" onClick={() => openVideoModal('https://player.vimeo.com/video/1000823828?h=279281a8df')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20.191" height="22.92" viewBox="0 0 20.191 22.92">
                          <path d="M9.086,27.982a2.255,2.255,0,0,1-1.1-.291,2.442,2.442,0,0,1-1.228-2.138V7.492A2.442,2.442,0,0,1,7.982,5.353a2.242,2.242,0,0,1,2.257.028l15.641,9.24a2.226,2.226,0,0,1,0,3.8L10.236,27.663a2.262,2.262,0,0,1-1.151.319Z" transform="translate(-6.754 -5.063)" fill="#c0321f" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <p style={{ marginTop: '15px', fontStyle: 'italic', color: '#555', fontSize: '16px' }}>
                Maguire Peterson's Dad &ndash; "This completely changed the way coaches responded..."
              </p>
            </div>
            <div style={{ flex: '1 1 400px', maxWidth: '560px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ background: '#f5f5f5', borderRadius: '8px', padding: '40px', textAlign: 'center' }}>
                <p style={{ fontSize: '18px', fontStyle: 'italic', color: '#555', lineHeight: '30px' }}>
                  "Additional customer testimonial coming soon &ndash; athlete/parent success story."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THE TRUTH ABOUT RECRUITING VIDEOS */}
      <section className="carrer-preferred-sec" style={{ background: '#1a1a2e' }}>
        <div className="container">
          <div className="top-block">
            <div className="title">The Truth About Recruiting Videos</div>
            <h3 className="sub-title">Most Families Get This WRONG</h3>
          </div>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{ display: 'inline-flex', gap: '40px', flexWrap: 'wrap', justifyContent: 'center' }}>
              <div style={{ color: '#ff4444', fontSize: '20px', fontWeight: 600 }}>
                &#10060; Getting Video is EASY...
              </div>
              <div style={{ color: '#00b9ff', fontSize: '20px', fontWeight: 600 }}>
                &#10004; Getting Coaches to RESPOND is HARD
              </div>
            </div>
          </div>
          <div className="preferred-list">
            <div className="item">
              <div className="detail-box">
                <h4>The Biggest Mistake We See</h4>
                <p>
                  Average Highlight Videos = Zero Coach Interest. College coaches
                  are EXTREMELY BUSY and receive THOUSANDS of athlete messages
                  every month.
                </p>
              </div>
            </div>
            <div className="item">
              <div className="detail-box">
                <h4>Ask Yourself</h4>
                <p>
                  Does your video STOP the scroll instantly? Are you using the
                  exact angles coaches want? Is your video sequenced to hook
                  coaches in the first 10&ndash;15 seconds?
                </p>
              </div>
            </div>
            <div className="item">
              <div className="detail-box">
                <h4>Reality Check</h4>
                <p>
                  A scroll-stopping highlight video is no longer optional &ndash;
                  it's a MUST. Most programs operate on ~$2,000/year recruiting
                  budgets. They are evaluating YOU online.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* IF YOUR VIDEO ISN'T DIALED IN */}
      <section className="diy-warning-section" style={{ background: '#fff', padding: '60px 0' }}>
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <h3 style={{ fontSize: '30px', fontWeight: 600, color: '#333', marginBottom: '30px' }}>
              Most Programs Aren't Coming to See You
            </h3>
            <p style={{ fontSize: '18px', color: '#555', lineHeight: '30px', marginBottom: '30px' }}>
              Many non-D1 programs operate on ~$2,000/year recruiting budgets.
              They're not traveling across the country... They are evaluating YOU online.
            </p>
            <h4 style={{ fontSize: '22px', fontWeight: 600, color: '#c0321f', marginBottom: '20px' }}>
              If Your Video Isn't Dialed In:
            </h4>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center', marginBottom: '30px' }}>
              <div style={{ background: '#fff5f5', borderRadius: '8px', padding: '15px 25px', color: '#c0321f', fontWeight: 500 }}>
                Wrong angles
              </div>
              <div style={{ background: '#fff5f5', borderRadius: '8px', padding: '15px 25px', color: '#c0321f', fontWeight: 500 }}>
                Poor sequencing
              </div>
              <div style={{ background: '#fff5f5', borderRadius: '8px', padding: '15px 25px', color: '#c0321f', fontWeight: 500 }}>
                No professional polish
              </div>
            </div>
            <p style={{ fontSize: '18px', color: '#333', fontWeight: 600, lineHeight: '30px' }}>
              You're not just losing views... You're losing scholarship opportunities.
            </p>
          </div>
        </div>
      </section>

      {/* THE SPORTSFORCE WAY */}
      <section className="carrer-preferred-sec">
        <div className="container">
          <div className="top-block">
            <div className="title">The Solution</div>
            <h3 className="sub-title">The SportsForce Way</h3>
          </div>
          <div style={{ textAlign: 'center', color: '#e1e1e1', fontSize: '20px', fontWeight: 600, marginBottom: '30px' }}>
            99% of Recruiting = Packaging + Promotion
          </div>
          <div className="preferred-list">
            <div className="item">
              <div className="icon-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#00b9ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m15.5 7.5 2 2m-7-7L12 4l-1 1 3 3 1-1 1.5 1.5" />
                  <rect x="2" y="14" width="8" height="8" rx="1" />
                  <rect x="14" y="2" width="8" height="8" rx="1" />
                </svg>
              </div>
              <div className="detail-box">
                <h4>Grabs Attention in Seconds</h4>
                <p>We turn your raw footage into a high-impact recruiting asset that shows coaches EXACTLY what they want.</p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#00b9ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
              <div className="detail-box">
                <h4>Increases Responses</h4>
                <p>DMs, texts, and calls from coaches. Positions you ahead of 90% of athletes.</p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#00b9ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5C7 4 7 7 7 7" />
                  <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5C17 4 17 7 17 7" />
                  <path d="M4 22h16" />
                  <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
                  <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
                  <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
                </svg>
              </div>
              <div className="detail-box">
                <h4>15+ Years of Expertise</h4>
                <p>Thousands of athletes helped. Built specifically for today's recruiting landscape.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FORMULA */}
      <section className="get-started-sec" style={{ backgroundImage: 'none', background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)' }}>
        <div className="container">
          <div className="get-started-flexbox" style={{ position: 'relative', zIndex: 1 }}>
            <h3 className="sec-title" style={{ color: '#fff' }}>
              The Right Highlight Video + The Right Promotion + The Right College Coach = RESULTS
            </h3>
            <div className="button-wrap">
              <a className="btn" href="#diy-offer-section">
                Get Started Today
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* OFFER SECTION */}
      <section id="diy-offer-section" className="diy-offer-section" style={{ background: '#fff', padding: '80px 0' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '50px' }}>
            <h2 style={{ fontSize: '36px', fontWeight: 700, color: '#333', marginBottom: '10px' }}>
              The Complete College Exposure &amp; Recruiting Video Bundle
            </h2>
            <p style={{ fontSize: '20px', color: '#555', marginBottom: '5px' }}>
              Everything Your Athlete Needs to Get NOTICED by College Coaches
            </p>
            <p style={{ fontSize: '16px', color: '#00b9ff', fontWeight: 600 }}>
              Built to help you stand out, get seen, and get responses &mdash; FAST.
            </p>
          </div>

          {/* What's Included */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center', marginBottom: '50px' }}>
            {/* Profile Membership */}
            <div style={{ flex: '1 1 300px', maxWidth: '350px', background: '#f9f9f9', borderRadius: '12px', padding: '30px', border: '2px solid #e0e0e0' }}>
              <div style={{ fontSize: '40px', marginBottom: '15px', textAlign: 'center' }}>&#128202;</div>
              <h4 style={{ fontSize: '20px', fontWeight: 700, color: '#333', marginBottom: '15px', textAlign: 'center' }}>
                1-Year DIY Recruiting Profile Membership
              </h4>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ padding: '8px 0', color: '#555', fontSize: '15px' }}>&#10004; World-class recruiting tools</li>
                <li style={{ padding: '8px 0', color: '#555', fontSize: '15px' }}>&#10004; NCAA coach contact database</li>
                <li style={{ padding: '8px 0', color: '#555', fontSize: '15px' }}>&#10004; Athlete profile coaches can evaluate instantly</li>
              </ul>
              <div style={{ textAlign: 'center', marginTop: '15px', color: '#999', fontWeight: 600 }}>$499 Value</div>
            </div>

            {/* Highlight Video */}
            <div style={{ flex: '1 1 300px', maxWidth: '350px', background: '#f9f9f9', borderRadius: '12px', padding: '30px', border: '2px solid #00b9ff' }}>
              <div style={{ fontSize: '40px', marginBottom: '15px', textAlign: 'center' }}>&#127909;</div>
              <h4 style={{ fontSize: '20px', fontWeight: 700, color: '#333', marginBottom: '15px', textAlign: 'center' }}>
                Professional Highlight Video Edit
              </h4>
              <p style={{ color: '#555', fontSize: '15px', marginBottom: '15px', textAlign: 'center' }}>
                Send us your clips... we handle the rest.
              </p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ padding: '8px 0', color: '#555', fontSize: '15px' }}>&#10004; High-impact video (up to 2 minutes)</li>
                <li style={{ padding: '8px 0', color: '#555', fontSize: '15px' }}>&#10004; Coach-approved sequencing &amp; angles</li>
                <li style={{ padding: '8px 0', color: '#555', fontSize: '15px' }}>&#10004; Grabs attention in 30 seconds or less</li>
              </ul>
              <div style={{ textAlign: 'center', marginTop: '15px', color: '#999', fontWeight: 600 }}>$299 Value</div>
            </div>

            {/* Feature Tweet */}
            <div style={{ flex: '1 1 300px', maxWidth: '350px', background: '#f9f9f9', borderRadius: '12px', padding: '30px', border: '2px solid #e0e0e0' }}>
              <div style={{ fontSize: '40px', marginBottom: '15px', textAlign: 'center' }}>&#128038;</div>
              <h4 style={{ fontSize: '20px', fontWeight: 700, color: '#333', marginBottom: '15px', textAlign: 'center' }}>
                Feature Tweet Exposure
              </h4>
              <p style={{ color: '#555', fontSize: '15px', marginBottom: '15px', textAlign: 'center' }}>
                Get your video in front of the RIGHT audience.
              </p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ padding: '8px 0', color: '#555', fontSize: '15px' }}>&#10004; Featured to 78,000+ followers</li>
                <li style={{ padding: '8px 0', color: '#555', fontSize: '15px' }}>&#10004; Includes 2,000+ active college coaches</li>
                <li style={{ padding: '8px 0', color: '#555', fontSize: '15px' }}>&#10004; Real visibility = real opportunities</li>
              </ul>
              <div style={{ textAlign: 'center', marginTop: '15px', color: '#999', fontWeight: 600 }}>$199 Value</div>
            </div>
          </div>

          {/* BONUSES */}
          <div style={{ maxWidth: '700px', margin: '0 auto 50px', background: '#fffbe6', borderRadius: '12px', padding: '30px', border: '2px solid #ffce30' }}>
            <h4 style={{ fontSize: '22px', fontWeight: 700, color: '#333', textAlign: 'center', marginBottom: '20px' }}>
              &#127873; BONUSES (Limited Time)
            </h4>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'center' }}>
              <div style={{ flex: '1 1 200px', textAlign: 'center', padding: '10px' }}>
                <div style={{ fontWeight: 600, color: '#333' }}>Video Shooting Tutorial</div>
                <div style={{ color: '#999' }}>$99 Value</div>
              </div>
              <div style={{ flex: '1 1 200px', textAlign: 'center', padding: '10px' }}>
                <div style={{ fontWeight: 600, color: '#333' }}>Recruiting Email Template Library</div>
                <div style={{ color: '#999' }}>$199 Value</div>
              </div>
              <div style={{ flex: '1 1 200px', textAlign: 'center', padding: '10px' }}>
                <div style={{ fontWeight: 600, color: '#333' }}>1-on-1 College Assessment Call</div>
                <div style={{ color: '#999' }}>$99 Value</div>
              </div>
            </div>
          </div>

          {/* PRICING */}
          <div style={{ maxWidth: '500px', margin: '0 auto', textAlign: 'center', background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)', borderRadius: '16px', padding: '40px 30px', color: '#fff' }}>
            <div style={{ fontSize: '16px', color: '#999', marginBottom: '5px' }}>Total Value: <span style={{ textDecoration: 'line-through' }}>$1,496</span></div>
            <div style={{ fontSize: '16px', color: '#999', marginBottom: '20px' }}>Normal Price: <span style={{ textDecoration: 'line-through' }}>$799</span></div>
            <div style={{ fontSize: '18px', color: '#00b9ff', fontWeight: 600, marginBottom: '10px' }}>
              TODAY'S SPECIAL OFFER
            </div>
            <div style={{ fontSize: '48px', fontWeight: 800, color: '#fff', marginBottom: '5px' }}>$399</div>
            <div style={{ fontSize: '16px', color: '#ffce30', marginBottom: '5px' }}>
              Use Code: <strong>[INSERT CODE]</strong> for an additional $100 OFF
            </div>
            <div style={{ fontSize: '28px', fontWeight: 800, color: '#00b9ff', marginBottom: '20px' }}>
              FINAL PRICE: $299
            </div>
            <a
              className="btn"
              href="https://www.sportsforceonline.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'inline-block', padding: '15px 40px', fontSize: '18px', fontWeight: 700, borderRadius: '6px' }}
            >
              Claim Your Spot &ndash; $299
            </a>
            <div style={{ marginTop: '20px', fontSize: '14px', color: '#ff6b6b' }}>
              &#9888; Only 10 athletes per month (to ensure high-quality production)
            </div>
          </div>
        </div>
      </section>

      {/* WHY SPORTSFORCE */}
      <section className="carrer-preferred-sec">
        <div className="container">
          <div className="top-block">
            <h3 className="sub-title">Why SportsForce?</h3>
          </div>
          <div className="preferred-list">
            <div className="item">
              <div className="icon-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#00b9ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
              </div>
              <div className="detail-box">
                <h4>Deep Expertise</h4>
                <p>Helping athletes get recruited since 2008. Thousands of successful college scholarships.</p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#00b9ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
                </svg>
              </div>
              <div className="detail-box">
                <h4>We Actually BUILD the Assets</h4>
                <p>Not just advice... We create the videos, profiles, and exposure coaches want.</p>
              </div>
            </div>
            <div className="item">
              <div className="icon-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#00b9ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="12" y1="20" x2="12" y2="10" />
                  <line x1="18" y1="20" x2="18" y2="4" />
                  <line x1="6" y1="20" x2="6" y2="16" />
                </svg>
              </div>
              <div className="detail-box">
                <h4>Proven Exposure That Works</h4>
                <p>Feature tweets generate thousands of views, seen by college recruiters who matter most.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="get-started-sec" style={{ backgroundImage: 'none', background: 'linear-gradient(135deg, #c0321f 0%, #e74c3c 100%)' }}>
        <div className="container">
          <div className="get-started-flexbox" style={{ position: 'relative', zIndex: 1 }}>
            <h3 className="sec-title" style={{ color: '#fff' }}>
              Ready to Get Recruited? Stop guessing. Start getting noticed.
            </h3>
            <div className="button-wrap">
              <a
                className="btn"
                href="#diy-offer-section"
                style={{ background: '#fff', color: '#c0321f' }}
              >
                Claim Your Spot &ndash; $299
              </a>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.8)', marginTop: '15px', fontSize: '14px' }}>
              &#9888; Only 10 spots available this month. Don't miss your chance to stand out.
            </p>
          </div>
        </div>
      </section>

      <footer id="footer"></footer>
      <VideoPop
        isTestSingle={isVideoPop}
        setIsTestSingle={() => setIsVideoPop(false)}
        vidID={vidID}
      />
    </>
  );
};

export default DiyHvOffer;
